import store from "@/vue/planning/store/store"

// Types
import { IReservation, ISelectedPrestation } from "@/types"
const getReservationClickData = (): IReservation => {
	const beginDateParts =
		store.state.dates["BeginDate"] && store.state.dates["BeginDate"].split("/")
	const endDateParts =
		store.state.dates["EndDate"] && store.state.dates["EndDate"].split("/")
	const liheId =
		store.getters.selectedPrestations[0].prestation.fusionId ||
		store.state.liheData.id
	const liheName =
		store.getters.selectedPrestations[0].prestation.liheName ||
		store.state.liheData.name
	const participants = store.state.participants
	const beginDate = beginDateParts
		? `${beginDateParts[2]}-${beginDateParts[1]}-${beginDateParts[0]}`
		: ""
	const endDate = endDateParts
		? `${endDateParts[2]}-${endDateParts[1]}-${endDateParts[0]}`
		: ""

	const duration =
		store.getters.selectedPrestations &&
		store.getters.selectedPrestations[0].prestation?.duration
	const prestationsIds =
		store.getters.selectedPrestations &&
		store.getters.selectedPrestations.map((prest: ISelectedPrestation) => {
			return prest.prestation.prestIdSource
		})
	const prestationsNames =
		store.getters.selectedPrestations &&
		store.getters.selectedPrestations.map((prest: ISelectedPrestation) => {
			return prest.prestation.prestName
		})
	const totalPrice = store.getters.totals.totalPrice

	const { station, region } = store.state.liheData
	return {
		quantity: participants.length,
		liheId,
		liheName,
		duration,
		beginDate,
		endDate,
		prestationsIds,
		prestationsNames,
		totalPrice,
		station,
		region,
	}
}

export default getReservationClickData
